<template>
  <el-carousel height="60px" direction="vertical" arrow="never" indicator-position="none" class="notice-box">
    <el-carousel-item v-for="item in newsList" :key="'news'+item.id">
      <div class="new-container">
        <img src="../../../assets/img/new-icon.png" class="new-icon">
        <div class="new-table">
          <ul>
            <li><a href="javascript:;">{{item.title}}</a></li>
          </ul>
        </div>
        <div class="new-more">
          <router-link :to="'/News/'+ item.id" class="newsBtn" >
            <span>查看详情</span>
            <img src="../../../assets/img/icon-more.png">
          </router-link>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
<!---->

</template>

<script>
import '../../../assets/css/index.css'
import {ApiGetMsgList} from '../../../net/home/index.js'
export default {
  data: function () {
    return {
      newsList: []
    }
  },
  methods:{
    getMsgList: function () {
      const prames = {
        pageNum: 1,
        pageSize: 4,
        platform: 'pc'
      }
      ApiGetMsgList(prames).then(res=>{
        if (res.code == 200) {
          this.newsList = res.pc.details
        }
      //  console.log('消息', res)
      })
    }
  },
  mounted: function () {
    this.getMsgList()
  }
}
</script>

<style scoped>
.notice-box{
  margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/children/notice.vue